// Lazy loader for the Google Maps JS API. Idempotent — the script tag is
// inserted once per page; every subsequent caller awaits the same promise.
let promise = null

export function loadGoogleMaps(apiKey, { libraries = ['places'] } = {}) {
  if (typeof window === 'undefined') return Promise.reject(new Error('no window'))
  if (window.google?.maps?.places) return Promise.resolve(window.google)
  if (promise) return promise

  promise = new Promise((resolve, reject) => {
    const cbName = `__gmaps_cb_${Date.now().toString(36)}`
    window[cbName] = () => {
      delete window[cbName]
      if (window.google?.maps) resolve(window.google)
      else reject(new Error('Google Maps failed to initialise'))
    }
    const s = document.createElement('script')
    const params = new URLSearchParams({
      key:       apiKey,
      libraries: libraries.join(','),
      v:         'weekly',
      callback:  cbName,
    })
    s.src = `https://maps.googleapis.com/maps/api/js?${params}`
    s.async = true
    s.defer = true
    s.onerror = () => {
      delete window[cbName]
      promise = null
      reject(new Error('Failed to load Google Maps script'))
    }
    document.head.appendChild(s)
  })
  return promise
}

/** Build the canonical https://www.google.com/maps?q=lat,lng share link. */
export function buildMapUrl(lat, lng) {
  if (lat == null || lng == null) return null
  return `https://www.google.com/maps?q=${lat.toFixed(6)},${lng.toFixed(6)}`
}
